/**
 * Prefetch heavy route chunks during idle time.
 * Called on app mount (auth-independent) — JS chunk downloads don't need authentication.
 * Dynamic imports warm the module cache so React.lazy resolves instantly on navigation.
 */
export function prefetchRouteChunks(): void {
  const prefetch = () => {
    // Templates page (lightweight but frequently accessed)
    import('@/features/templates/pages/TemplatesPage').catch(() => {});
    // Designer page (heavy — many dialog/bridge imports)
    import('@/features/designer/pages/DesignerPage').catch(() => {});
    // MDM Devices page (heavy — actions catalog + classification + capability diagnostic)
    import('@/features/mdm-devices/pages/DevicesPage').catch(() => {});
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetch);
  } else {
    // Safari fallback
    setTimeout(prefetch, 2000);
  }
}
